<template>
  <iframe
    title="Iframe Analytics"
    ref="iframeAnalytics"
    :src="`${analyticsUrl}dashboards/oms/global?tenant=${currentGroup.name}&hide_menu=true&disableSSO=1&dark=${$vuetify.theme.dark}`"
  ></iframe>
</template>

<script>
  import RenderHtmlDirective from '@/directives/RenderHtmlDirective'
  import { mapState } from 'vuex'

  export default {
    name: 'OrderDashboard',
    directives: {
      RenderHtmlDirective: RenderHtmlDirective,
    },
    data() {
      return {
        analyticsUrl: process.env.VUE_APP_ANALYTICS_URL,
      }
    },
    created() {
      // Wait for the analytics to be ready
      window.addEventListener('message', async (event) => {
        if (event.data === 'analytics-ready') {
          // Make sure access token is refreshed before sending it to the analytics
          await this.$auth.isAuthenticated()

          // Send the access token to the analytics
          this.$refs.iframeAnalytics.contentWindow.postMessage({ token: this.$auth.accessToken }, '*')
        }
      })
    },
    computed: {
      ...mapState(['currentGroup']),
    },
  }
</script>

<style scoped>
  iframe {
    height: calc(100vh - 70px);
    width: 100%;
    border: none;
    padding: 0;
    margin: 0;
  }
</style>
